import React from "react";
import { InformationCircleIcon } from "@heroicons/react/solid";

const MessageAlert = ({
  type = "info",
  message = (
    <>
      <p className="font-bold text-2xl">
        Phase 1 is no longer available.
      </p>
      <p className="mt-3 text-lg text-gray-700">
        All Phase 1 users have been migrated to{" "}
        <a
          href="https://phase2.kipplo.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold underline decoration-2 underline-offset-2 text-blue-700 hover:text-blue-900 transition-colors"
        >
          Phase 2
        </a>
        . Please log in there to continue using your account. If you encounter any issues, try the "Forgot Password" option.
      </p>
      <p className="mt-3 text-lg text-gray-600 italic">
        Phase 1 access has been permanently disabled.
      </p>
      <p className="mt-3 text-lg text-gray-700">
        For further assistance, contact{" "}
        <a
          // href="mailto:support@kipplo.com"
          className="font-semibold underline decoration-2 underline-offset-2 text-blue-700 hover:text-blue-900 transition-colors"
        >
          support@kipplo.com
        </a>
        .
      </p>
    </>
  ),
}) => {
  if (!message) return null;

  const styles = {
    info: "bg-blue-50 text-blue-800 border-blue-300",
    success: "bg-green-50 text-green-800 border-green-300",
    error: "bg-red-50 text-red-800 border-red-300",
  };

  return (
    <div
      className={`flex items-start gap-5 border rounded-2xl px-8 py-6 text-lg shadow-lg ${styles[type]}`}
      role="alert"
    >
      <div className="mt-1">
        <InformationCircleIcon className="w-10 h-10 text-blue-600 flex-shrink-0" />
      </div>
      <div className="flex-1 leading-relaxed">
        {message}
      </div>
    </div>
  );
};

export default MessageAlert;
